import React, { Component } from "react";
import _ from "lodash";
import { NavLink } from "react-router-dom";
import {projectsEditInitNav} from "../store/config";

export default class ProjectsEditSubnav extends Component {
	render() {
		let { params, projects } = this.props;
		let currentStep = _.find(projectsEditInitNav, {step: _.toInteger(this.props.step)});
		return <div className="subnavigation-projects crud">
			<div className="level">
				<div className="level-item subnav-section">
					<div className="details">
						<h5>{currentStep && currentStep.title}</h5>
						{/*<h6>{params.modality === 'modalidad-i' ? 'Modalidad I' : (params.modality === 'modalidad-ii' ? 'Modalidad II' : 'Modalidad III')}</h6>*/}
					</div>
				</div>
				<div className="level-item subnav-step">
					<div className="details">
						{projectsEditInitNav &&
							<div className="level context-navigation">
								{projectsEditInitNav.map((item, k) => {
									let projectLink = _.replace(_.replace(item.url, ':id', params.id), 'undefined', '');

									return (
										<div className="level-item" key={k}>
											<NavLink className="step" to={projectLink} activeClassName="active" disabled={projects.isFetching}>
												<p>{item.step}</p>
												<span>{item.title}</span>
											</NavLink>
										</div>
									)
								})}
							</div>}
					</div>
				</div>
			</div>
		</div>;
	}
}


// WEBPACK FOOTER //
// ./src/elements/projects-edit-subnav.jsx